import _ from 'lodash';
import MqttGateway from './lib/mqtt_gateway';

export default class SearchGateway extends MqttGateway {
  get version() {
    return '3';
  }

  get topicPattern() {
    return 'search/+';
  }

  fetch({ id, query, requestedAt }) {
    this._fetch([], { query, requestedAt }, id);
  }

  onFetchResponse(dto, topic, parsedTopicParams, correlationId) {
    const searchResult = _.extend(dto, { id: correlationId });
    this.notifyObservers('handleSearchResult', searchResult);
  }

  onFetchError(errorDto) {
    this.notifyObservers('handleSearchResultError', errorDto);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/gateways/search_gateway.js